export default {
  values: {
    xs: 0,
    sm: 630,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};
